import gql from 'graphql-tag';

export default gql`
query getAllSnippetsV2ForAdmin {
  snippets_v2(order_by: { name: asc }) {
    snippet_id
    group_id
    name
    data
    created_at
    updated_at
    group {
      name
    }
    snippets_v2_tags {
      tag {
        tag_id
        name
      }
    }
  }
}
`;
